import { useState } from "react";

const DRIVE_FILE_ID = "1pHzs8D9sLGpELnOLeJogoP7RqlFgszzg";
const PDF_URL = `https://drive.google.com/file/d/${DRIVE_FILE_ID}/view?usp=sharing`;
const PDF_EMBED_URL = `https://drive.google.com/file/d/${DRIVE_FILE_ID}/preview`;
const PDF_DOWNLOAD_URL = `https://drive.google.com/uc?export=download&id=${DRIVE_FILE_ID}`;

export default function ProfileSection() {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = PDF_DOWNLOAD_URL;
    a.download = "Ho-so-nang-luc-CONG-BO.pdf";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
  };

  return (
    <section id="ho-so-nang-luc" className="py-16 md:py-24 bg-[#F8F9F4]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 bg-[#0E5C3A]/10 text-[#0E5C3A] text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            <i className="ri-file-text-line"></i>
            Tài liệu doanh nghiệp
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 leading-tight mb-4">
            Công bố năng lực doanh nghiệp
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Tìm hiểu đầy đủ về năng lực, kinh nghiệm và các dịch vụ thí nghiệm 
            vật liệu xây dựng của chúng tôi qua hồ sơ năng lực chính thức.
          </p>
        </div>

        {/* Main content */}
        <div className="flex flex-col lg:flex-row gap-8 items-start">
          {/* PDF Preview */}
          <div className="flex-1 w-full">
            <div className="bg-white rounded-lg overflow-hidden border border-gray-200 relative">
              {/* Preview header bar */}
              <div className="flex items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200">
                <div className="w-8 h-8 flex items-center justify-center bg-red-50 rounded">
                  <i className="ri-file-pdf-2-line text-red-500 text-lg"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-gray-700 truncate">
                    HỒ SƠ NĂNG LỰC – CÔNG BỐ
                  </p>
                  <p className="text-xs text-gray-400">Tài liệu PDF chính thức</p>
                </div>
                <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded whitespace-nowrap">
                  Xem trước
                </span>
              </div>

              {/* PDF iframe */}
              <div className="relative w-full" style={{ height: "620px" }}>
                {!isLoaded && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-50 z-10">
                    <div className="w-12 h-12 flex items-center justify-center mb-3">
                      <i className="ri-loader-4-line text-3xl text-[#0E5C3A] animate-spin"></i>
                    </div>
                    <p className="text-gray-500 text-sm">Đang tải tài liệu...</p>
                  </div>
                )}
                <iframe
                  src={PDF_EMBED_URL}
                  className="w-full h-full border-0"
                  title="Hồ sơ năng lực doanh nghiệp"
                  onLoad={() => setIsLoaded(true)}
                  allow="fullscreen"
                />
              </div>
            </div>
          </div>

          {/* Side info panel */}
          <div className="w-full lg:w-80 flex flex-col gap-5">
            {/* Info card */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-base font-bold text-gray-800 mb-4 flex items-center gap-2">
                <div className="w-6 h-6 flex items-center justify-center text-[#0E5C3A]">
                  <i className="ri-information-line"></i>
                </div>
                Thông tin tài liệu
              </h3>
              <ul className="space-y-3">
                {[
                  { icon: "ri-building-2-line", label: "Đơn vị phát hành", value: "CÔNG BỐ" },
                  { icon: "ri-file-pdf-2-line", label: "Định dạng", value: "PDF" },
                  { icon: "ri-calendar-line", label: "Ngày cập nhật", value: "30/03/2026" },
                  { icon: "ri-shield-check-line", label: "Tình trạng", value: "Chính thức" },
                ].map((item) => (
                  <li key={item.label} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center text-[#0E5C3A] mt-0.5 shrink-0">
                      <i className={`${item.icon} text-sm`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">{item.label}</p>
                      <p className="text-sm font-semibold text-gray-700">{item.value}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            {/* Download button */}
            <button
              onClick={handleDownload}
              className="w-full flex items-center justify-center gap-3 bg-[#0E5C3A] hover:bg-[#0a4a2e] text-white px-6 py-4 rounded-md font-bold text-base transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-download-2-line text-lg"></i>
              </div>
              Tải xuống hồ sơ năng lực
            </button>

            <a
              href={PDF_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full flex items-center justify-center gap-3 border-2 border-[#0E5C3A] text-[#0E5C3A] hover:bg-[#0E5C3A] hover:text-white px-6 py-3.5 rounded-md font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-external-link-line"></i>
              </div>
              Mở toàn màn hình
            </a>

            {/* Highlight features */}
            <div className="bg-[#0E5C3A]/5 rounded-lg border border-[#0E5C3A]/15 p-5">
              <p className="text-xs font-semibold text-[#0E5C3A] uppercase tracking-wide mb-3">
                Nội dung hồ sơ bao gồm
              </p>
              <ul className="space-y-2">
                {[
                  "Giới thiệu năng lực công ty",
                  "Danh mục thiết bị thí nghiệm",
                  "Các chứng chỉ & công nhận",
                  "Danh sách công trình tiêu biểu",
                  "Quy trình thực hiện dịch vụ",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-gray-600">
                    <div className="w-4 h-4 flex items-center justify-center text-[#0E5C3A] shrink-0">
                      <i className="ri-checkbox-circle-line text-sm"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
